import Query from '../../../../../components/Report';

export const query = ({ prompt_uids = [], platforms = '', gsc_domain = '' }) =>
    new Query('ai-tracking-facts', {
        // prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
    });

function setKeywordUids(ids) {
    return `and prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setPlatforms(platforms) {
    return `and platform in (${platforms.map((item) => `'${item}'`)})`;
}
